import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import style from './audit-queue.scss';
import SliderWrapper from 'jd-library/SliderWrapper';
import historyHandler from 'jd-library/historyHandler';
import toastMessageActions from "jd-library/toastMessageActions";
import FormCheck from 'jd-library/FormCheck';
import Modal from 'jd-library/Modal';
import Button from 'jd-library/Button';
import axios from 'axios';
import { identifyAuditFlow } from '../../utills';
import { getListingData } from '../../actions/products';

const initialCheckList = {
    raq : false,
    faq : false,
    c1q : false,
    c2q : false,
    c3q : false,
    daq : false,
    oaq : false
}
const queueListMap = {
    raq : 'REGULAR',
    faq : 'FURLOUGH',
    c1q : 'CONTRACTOR',
    c2q : 'CONTRACTORV2',
    c3q : 'CONTRACTORV3',
    daq : 'DB-EXECUTIVE',
    oaq : 'ONBOARDREP'
}
const RemoveAuditQueueSlider = props => {
    const[checkList,updateCheckList] = useState({
        ...initialCheckList
    })
    const[auditStats,updateAuditStats] = useState({})
    const[queueModal,toggleQueueModal] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const docIdCheck = identifyAuditFlow({query: true});
        let docId = "";
        if(props.session.docId){
            docId = props.session.docId;
        }else if(docIdCheck.searchBy == 'docId'){
            docId = docIdCheck.docId;
        }
        axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=getAuditQueueCounts&docid=${docId}`)
			.then(({data})=>{
				if(data.isSuccess){
					let result = {
                        regularDocIdCount : data.data.regularCnt,
                        furloughDocIdCount : data.data.furloughCnt,
                        contractorDocIdCount : data.data.contractorV1,
                        contractorV2DocIdCount : data.data.contractorV2,
                        contractorV3DocIdCount : data.data.contractorV3,
                        dbQueueDocIdCount : data.data.dbQueue,
                        onboardQueueDocIdCount : data.data.onboarding
                    }
                    updateAuditStats(result);
				}
			})
    },[])

    const queueList=[{
        key : 'raq',
        label: 'Regular Audit Queue',
        counts: auditStats.regularDocIdCount ? auditStats.regularDocIdCount : 0,
        isChecked : checkList.raq
    }, {
        key : 'faq',
        label: 'Furlough Audit Queue',
        counts: auditStats.furloughDocIdCount ? auditStats.furloughDocIdCount : 0,
        isChecked : checkList.faq
    }, {
        key : 'c1q',
        label: 'Contractor v1 Audit Queue',
        counts: auditStats.contractorDocIdCount ? auditStats.contractorDocIdCount : 0,
        isChecked : checkList.c1q
    },{
        key : 'c2q',
        label: 'Contractor v2 Audit Queue',
        counts: auditStats.contractorV2DocIdCount ? auditStats.contractorV2DocIdCount : 0,
        isChecked : checkList.c2q
    },{
        key : 'c3q',
        label: 'Contractor v3 Audit Queue',
        counts: auditStats.contractorV3DocIdCount ? auditStats.contractorV3DocIdCount : 0,
        isChecked : checkList.c3q
    },{
        key : 'daq',
        label: 'DB Audit Queue',
        counts: auditStats.dbQueueDocIdCount ? auditStats.dbQueueDocIdCount : 0,
        isChecked : checkList.daq
    },{
        key : 'oaq',
        label: 'Onboarding Audit Queue',
        counts: auditStats.onboardQueueDocIdCount ? auditStats.onboardQueueDocIdCount : 0 ,
        isChecked : checkList.oaq
    }];

    const handleChange = (e,key) => {
        let list = {...checkList};
        list[key] = e.target.checked;
        updateCheckList(list);
    }

    const onRemoveSave = (queueData) => {
        const docIdCheck = identifyAuditFlow({query: true});
        let docId = "";
        if(props.session.docId){
            docId = props.session.docId;
        }else if(docIdCheck.searchBy == 'docId'){
            docId = docIdCheck.docId;
        }
        axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=removeDocidFromAudit&docid=${docId}&queueType=${queueData.queueList.join(',')}`)
			.then(({data})=>{
				if(data.isSuccess){
					historyHandler.closeAll();
                    props.getListingData({tabKey: props.tabKey});
                    dispatch(toastMessageActions.showMessage({
                        message: `${queueData.productCount} Products Removed from ${queueData.queueCount} Audit Queues`,
                        showReduxToast: true,
                        animationTime :5000
                    }))
				}else{
                    dispatch(toastMessageActions.showMessage({
                        message: data.msg ? data.msg : `Something went wrong`,
                        showReduxToast: true,
                        animationTime :5000
                    }))
                }
			})
    }
    let companyName = (props.session && props.session.companyName) ? props.session.companyName : "Laxmi ennnnnn";
    let docId = (props.session && props.session.docId) ? props.session.docId : 'HGGJ&^^^%^VVBBBBBBBB';
    let cityArea = (props.session && props.session.city  && props.session.state) ? (props.session.city+' - '+props.session.state) : 'Mumbai-malad'
    let ownerInfo = (<>
        <div className={style['data-header']}>{companyName}</div>
        <div className={style['data-address']}>{cityArea}</div>
        <div className={style['data-docid-holder']}>
            {docId}
        </div>
    </>)

    let modalText = queueModal ? `This will remove <span class='remove-queue-highlight'>${queueModal.productCount}  Products</span> of this Doc ID from ${queueModal.queueCount} Audit Queues. This is Irreversible.` : '';

    let btnProps = [{
        children: 'Continue',
        onClick: () => {
            let result = {
                productCount : 0,
                queueCount : 0,
                queueList : []
            }
            queueList.map((cur) => {
                if(cur.isChecked){
                    result.productCount+=Number(cur.counts);
                    result.queueCount+=1;
                    result.queueList.push(queueListMap[cur.key]);
                }
            })
            toggleQueueModal(result);
        }
    }]
    return (
        <SliderWrapper
            header={{
                heading: "Remove Doc ID from Audit Queue",
                variant: 'white',
                className: 'remove-queue-header',
                leftIcons : [
                    {
                        className: 'icon-hdrBackNew',
                        onClick: () => {
                                historyHandler.closeCurrent();
                        }
                    }
                ]
            }}
            slider={{
                className: style['remove-queue']
            }}
            footer={{
                btnProps: btnProps
            }}
            onHidden={props.onHidden}
            isMobile = {props.isMobile}
        >
            <div className = {style['remove-queue-holder']}>
                <div className = {style['owner-info']}>
                    {ownerInfo}
                </div>
                <div className = {style['selection-holder']}>
                    <div className = {style['selection-header']}>Select Queues to Remove Doc ID from</div>
                    <div className = {style['selection-content']}>
                        {queueList.map((cur) => {
                            let label = `${cur.label} : ${cur.counts} Products`;
                            return (
								<FormCheck 
									className = {style['radio-input']}
									label = {label} 
									onChange = {(e) => handleChange(e,cur.key)} 
									labelClass = {'label-row '+style['option-label']} 
									checked = {cur.isChecked}
                                    type = {'circle'}
                                    disabled = {!cur.counts}
								/>
							)
                        })}
                    </div>
                </div>
            </div>
            {queueModal && <Modal
                            settings={{
                                modalId: 'removeAuditQueue',
                                variant: 'action',
                                class: 'remove-queue-modal'
                            }}
                            onHidden={() => {
                                toggleQueueModal(null);
                            }}
                        >
                            <Modal.CloseIcon />
                            <div className = {'remove-queue-section'}>
                                <div className = {'text'} dangerouslySetInnerHTML={{__html: modalText}}>
                                </div>
                                <div className = {'sub-text'}>
                                    Are you sure you want to remove this Doc ID from the selected queues?
                                </div>
                                <Button
                                    size="lg"
                                    className = {'remove-btn'}
                                    clickHandler = {() => {
                                        onRemoveSave(queueModal);
                                    }}
                                    block
                                >
                                    Yes, Remove
                                </Button>
                            </div>
                        </Modal>}
        </SliderWrapper>
    )
}

const mapStateToProps = state => {
	return {
		session: state.session,
		isMobile:state.library.deviceData.isMobile,
        tabKey: state.products.tabKey,
	};
};

export default connect(mapStateToProps, {
    getListingData,
    showToastMessage: toastMessageActions.showMessage,
})(RemoveAuditQueueSlider);